<mat-sidenav-container fullscreen>
   <mat-sidenav-content>
       <app-header *ngIf="head_footer"></app-header>
       <div [ngClass]="{'iframe_head_spance': !head_footer,'main-content': head_footer}">
           <div *ngIf="marquetext" class="marquee-text">
               <mat-icon> rss_feed</mat-icon>
               <marquee width="100%" direction="left">{{marquetext}}</marquee>
           </div>
           
<!-- casinoImg -->
<ng-container *ngIf="tokenCheck && dataLength">
 <div class="multi-card">
   <div class="scroll-card" style="padding: 14px;">
     <div class="itemsContain">
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/85246d801fef4d43a325637243661631_neon-thumbnails-18.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/912af3fca2144874b7b7ab2de03cf63a_neon-thumbnails-13.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group" style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/bce4691827854b14a631ba020001e847_neon-thumbnails-03.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/7343dec5ab5b4a36a6f926874f216389_neon-thumbnails-02.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
 
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/bce4691827854b14a631ba020001e847_neon-thumbnails-03.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/7343dec5ab5b4a36a6f926874f216389_neon-thumbnails-02.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/0730f21c63544456a0fa1eb250ae4992_neon-thumbnails-17.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/e910c519f92c41a58a9c59dc09e11250_neon-thumbnails-14.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/da0706276b4444d491846159bb1bf07a_neon-thumbnails-09.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/1afe8e32eb0d43a496d56979bf5e8b60_neon-thumbnails-10.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/89685a59c2dc46429b805875c37066a6_neon-thumbnails-16.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/8e0efab978a14ed483a794f9bb71ff96_neon-thumbnails-19.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/d67c61187ab248a58aefdeceff2edd96_neon-thumbnails-06.png"
             class="card-img-top" alt="...">
             <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/f42e05b9dcee4275b3e2addc2f73c606_neon-thumbnails-08.png"
             class="card-img-top" alt="...">
             <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
 
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/c33323b773474acf9f3c43b33e31ae91_neon-thumbnails-12.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/6fbb02d51cf044ea856eaa77faa77cd6_neon-thumbnails-15.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/23bce1903ca24717bfa7e6958f026aee_neon-thumbnails-07.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/2b26c9bd6797460dae6697ee093b0825_neon-thumbnails-05.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
         
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img src="https://images.supernowa.net/Document/GameImages/2594257625a948feaf82aee8447a8cfc_23-RNG-queen.jpg"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/198dec4fe9634a0493825705892cbd1f_neon-thumbnails-11.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
        
       </div>
       <div class="d-flex card-group " style="padding: 0px 5px 0px 5px;">
         <div class="card">
           <img
             src="https://images.supernowa.net/Document/GameImages/c88fc9c1bfc34e97b8e96a80007e34cf_neon-thumbnails-01.png"
             class="card-img-top" alt="...">
           <div class="button"><a href="#"> Play Now</a></div>
         </div>
 
       </div>
 
     </div>
                         
   </div>
 
 </div>
 </ng-container>
<!-- casinoImgEnd -->
   
         <!-- offerDesign end-->
        <div class="container-fluid">
          <div class="player_betl_lis_page">

            <div _ngcontent-qwe-c6="" class="event-box ng-tns-c6-0 ng-trigger ng-trigger-fadeInOut ng-star-inserted"><button _ngcontent-qwe-c6="" class="back-button" (click)="back_rout()"><i _ngcontent-qwe-c6="" class="fa fa-arrow-left" aria-hidden="true"></i></button></div>
         <div _ngcontent-uxm-c6="" class="evetns-tab ng-tns-c6-0 ng-star-inserted">
          <ul _ngcontent-uxm-c6="" class="ng-tns-c6-0" *ngIf="!betData">
             <li _ngcontent-uxm-c6="" class="ng-tns-c6-0 ">
                <button _ngcontent-uxm-c6="" class="tab-button" (click)="activeStatus='event'"  [ngClass]="activeStatus == 'event' ? 'active' : ''" type="button">
                   Events 
                   <svg _ngcontent-uxm-c6="" class="ng-tns-c6-0" viewBox="0 0 22.06 22.06" xmlns="http://www.w3.org/2000/svg">
                      <defs _ngcontent-uxm-c6="" class="ng-tns-c6-0">
                         <style _ngcontent-uxm-c6="" class="ng-tns-c6-0">.evetns-tab .cls-1,.evetns-tab .cls-2,.evetns-tab .cls-3,.evetns-tab .cls-4{stroke-miterlimit:10}.evetns-tab .cls-2,.evetns-tab .cls-3,.evetns-tab .cls-4{fill:none}.evetns-tab .cls-2,.evetns-tab .cls-3{stroke:#ffc11c;stroke-width:.94px}.evetns-tab .cls-3{stroke-dasharray:2.63 2.63}</style>
                      </defs>
                      <g _ngcontent-uxm-c6="" class="ng-tns-c6-0" data-name="Layer 2" id="Layer_2">
                         <g _ngcontent-uxm-c6="" class="ng-tns-c6-0" data-name="Layer 1" id="Layer_1-2">
                            <circle _ngcontent-uxm-c6="" class="cls-1" cx="11.03" cy="11.03" r="10.55"></circle>
                            <line _ngcontent-uxm-c6="" class="cls-2" x1="10.2" x2="4.46" y1="0.22" y2="19.58"></line>
                            <line _ngcontent-uxm-c6="" class="cls-2" x1="17.62" x2="11.88" y1="2.42" y2="21.78"></line>
                            <line _ngcontent-uxm-c6="" class="cls-2" x1="11.78" x2="11.45" y1="0.43" y2="1.55"></line>
                            <line _ngcontent-uxm-c6="" class="cls-3" x1="10.7" x2="6.59" y1="4.07" y2="17.94"></line>
                            <line _ngcontent-uxm-c6="" class="cls-2" x1="6.22" x2="5.88" y1="19.2" y2="20.32"></line>
                            <line _ngcontent-uxm-c6="" class="cls-2" x1="16.18" x2="15.85" y1="1.73" y2="2.86"></line>
                            <line _ngcontent-uxm-c6="" class="cls-3" x1="15.1" x2="10.99" y1="5.38" y2="19.24"></line>
                            <line _ngcontent-uxm-c6="" class="cls-2" x1="10.61" x2="10.28" y1="20.5" y2="21.63"></line>
                            <circle _ngcontent-uxm-c6="" class="cls-4" cx="11.03" cy="11.03" r="10.55"></circle>
                         </g>
                      </g>
                   </svg>
                </button>
             </li>
             <li _ngcontent-uxm-c6="" class="ng-tns-c6-0"><button _ngcontent-uxm-c6="" (click)="activeStatus='open';getMyBets(1)" class="tab-button" [ngClass]="activeStatus == 'open' ? 'active' : ''" type="button">Open Bets <i _ngcontent-uxm-c6="" class="fa fa-exchange" aria-hidden="true"></i></button></li>
             <li _ngcontent-uxm-c6="" class="ng-tns-c6-0"><button _ngcontent-uxm-c6="" (click)="activeStatus='settle';getMyBets(2)" class="tab-button " [ngClass]="activeStatus == 'settle' ? 'active' : ''" type="button">Settled Bets <i _ngcontent-uxm-c6="" class="fa fa-database" aria-hidden="true"></i></button></li>
          </ul>
       </div>

           <div class="play-battle-page events-card-main">
              <!-- virtualCricketData -->
              <ng-container >
               <div class="row"  *ngIf="activeStatus=='event' && !betData">
                  <div class="col-sm-4 play-row" *ngFor="let m of marketBattle">
                    <div class="play-card-box">
                    <h5 _ngcontent-igm-c24="" class="ng-tns-c24-2 text-center">{{m.eventName}} <!----><!----></h5>
                    <div _ngcontent-ifx-c6="" class="flex-container-box" routerLink="/payer-battle-market/{{m.marketId}}">
                      <div _ngcontent-ifx-c6="" class="fixed-logo"><img _ngcontent-ifx-c6="" class="ng-tns-c6-5" alt="team-logo" height="65" loading="lazy" width="76" src="assets/fantasty/{{(m?.slug).split('VS')[0].trim()}}.png" (error) ="onImgError($event)"></div>
                      <div _ngcontent-ifx-c6="" class="text-container">
                         <h4 _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.slug).split('VS')[0]}} <span _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.marketName).split('vs')[0]}}</span></h4>
                         <strong _ngcontent-ifx-c6="" class="ng-tns-c6-5">VS</strong>
                         <h4 _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.slug).split('VS')[1]}} <span _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.marketName).split('vs')[1]}}</span></h4>
                      </div>
                      <div _ngcontent-ifx-c6="" class="fixed-logo"><img _ngcontent-ifx-c6="" class="ng-tns-c6-5" alt="team-logo" height="65" loading="lazy" width="76" src="assets/fantasty/{{(m?.slug).split('VS')[1].trim()}}.png" (error) ="onImgError($event)"></div>
                   </div>

                   <div _ngcontent-ifx-c6="" class="small-card-footer">
                    <h6 _ngcontent-ifx-c6="" class="ng-tns-c6-5"><span _ngcontent-ifx-c6="" class="ng-tns-c6-5">Min {{m?.minlimit}}</span> | <span _ngcontent-ifx-c6="" class="ng-tns-c6-5">Max {{m?.maxlimit}}</span></h6>
                    <strong _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{m.openDate|date:'MMM d, y, h:mm:ss a'}}</strong>
                    <h6 _ngcontent-ifx-c6="" class="ng-tns-c6-5">Minimum Select : 5</h6>
                 </div>


                </div>
                  </div>
               </div>

               
               <div  class="table-box status-boxwrap" *ngIf="activeStatus!='event' && !betData">
                <div  class="row">
                <div class="col-sm-4 play-row" *ngFor="let m of bets">
                  <div class="play-card-box">
                    <div class="play-tilebox">
                      <h5 _ngcontent-igm-c24="" class="ng-tns-c24-2 text-center">{{m.eventName}} </h5>
                      <span *ngIf="m.result!='ACTIVE'"  _ngcontent-acq-c26="" class="status-box ng-tns-c26-2 ng-star-inserted"><i _ngcontent-acq-c26="" class="fa fa-check-circle" aria-hidden="true"></i> Settled</span>
                    </div>

                  <div _ngcontent-ifx-c6="" class="flex-container-box" (click)="openBet(m)">
                    <div _ngcontent-ifx-c6="" class="fixed-logo "><img _ngcontent-ifx-c6="" class="ng-tns-c6-5" alt="team-logo" height="65" loading="lazy" width="76" src="assets/fantasty/{{(m?.slug).split('VS')[0].trim()}}.png" (error) ="onImgError($event)"></div>
                    <div _ngcontent-ifx-c6="" class="text-container">
                       <h4 _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.slug).split('VS')[0]}} <span _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.marketName).split('vs')[0]}}</span></h4>
                       <strong _ngcontent-ifx-c6="" class="ng-tns-c6-5">VS</strong>
                       <h4 _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.slug).split('VS')[1]}} <span _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{(m?.marketName).split('vs')[1]}}</span></h4>
                    </div>
                    <div _ngcontent-ifx-c6="" class="fixed-logo"><img _ngcontent-ifx-c6="" class="ng-tns-c6-5" alt="team-logo" height="65" loading="lazy" width="76" src="assets/fantasty/{{(m?.slug).split('VS')[1].trim()}}.png" (error) ="onImgError($event)"></div>
                 </div>

                 <div _ngcontent-ifx-c6="" class="small-card-footer">
                  <h6 _ngcontent-ifx-c6="" class="ng-tns-c6-5"><span _ngcontent-ifx-c6="" class="ng-tns-c6-5">Min {{m?.minlimit}}</span> | <span _ngcontent-ifx-c6="" class="ng-tns-c6-5">Max {{m?.maxlimit}}</span></h6>
                  <strong _ngcontent-ifx-c6="" class="ng-tns-c6-5">{{m.placedTime|date:'MMM d, y, h:mm:ss a'}}</strong>
                  <h6 _ngcontent-ifx-c6="" class="ng-tns-c6-5">Minimum Select : 5</h6>
               </div>


              </div>
                </div>
              </div>
               </div>



               <div *ngIf="betData && marketBattle" _ngcontent-acq-c26="" class="left-div-w-70">
                <!----><!---->
                <div _ngcontent-acq-c26="" *ngIf="betViewData" class="event-box ng-tns-c26-2 ng-trigger ng-trigger-fadeInOut ng-star-inserted"><button _ngcontent-acq-c26="" class="back-button">
                  <i _ngcontent-acq-c26="" (click)="back()" class="fa fa-arrow-left" aria-hidden="true"></i></button> {{betViewData?.eventName}} <span _ngcontent-acq-c26="" (click)="openModalRules(fantastyrule)" class="rule">Rules</span></div>
                <!----><!----><!----><!---->
                <div _ngcontent-acq-c26=""  class="left-side start-evetns w-100 ng-tns-c26-2 ng-trigger ng-trigger-fadeInOut ng-star-inserted">
                   <div _ngcontent-acq-c26="" class="shadow-box">
                      <div _ngcontent-acq-c26="" class="flex-container-box teamboxformmob ks">
                         <div _ngcontent-acq-c26="" class="fixed-logo l1"><img _ngcontent-acq-c26="" class="ng-tns-c26-2" alt="team-logo" height="256" loading="lazy" width="255" src="assets/fantasty/{{(betViewData?.slug).split('VS')[0].trim()}}.png" (error) ="onImgError($event)"></div>
                         <div _ngcontent-acq-c26="" class="text-container">
                            <h4 _ngcontent-acq-c26="" class="ng-tns-c26-2">{{(betViewData?.slug).split('VS')[0]}} <span _ngcontent-acq-c26="" class="ng-tns-c26-2">{{(betViewData?.marketName).split('vs')[0]}}</span></h4>
                            <strong _ngcontent-acq-c26="" class="ng-tns-c26-2">VS</strong>
                            <h4 _ngcontent-acq-c26="" class="ng-tns-c26-2">{{(betViewData?.slug).split('VS')[1]}} <span _ngcontent-acq-c26="" class="ng-tns-c26-2">{{(betViewData?.marketName).split('vs')[1]}}</span></h4>
                            <div _ngcontent-acq-c26="" class="flex-items">
                               <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">Selected<span _ngcontent-acq-c26="" class="ng-tns-c26-2">4</span></h6>
                               <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">Your Points<span _ngcontent-acq-c26="" class="ng-tns-c26-2">{{userPoint}}</span></h6>
                               <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">Computer Points<span _ngcontent-acq-c26="" class="ng-tns-c26-2">{{computerPoint}}</span></h6>
                               <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">Bet Amount<span _ngcontent-acq-c26="" class="ng-tns-c26-2">{{betViewData?.stake/100}}</span></h6>
                               <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">Top loss run<span _ngcontent-acq-c26="" class="ng-tns-c26-2">100</span></h6>
                            </div>
                         </div>
                         <div _ngcontent-acq-c26="" class="fixed-logo l2"><img _ngcontent-acq-c26="" class="ng-tns-c26-2" alt="team-logo" height="256" loading="lazy" width="255" src="assets/fantasty/{{(betViewData?.slug).split('VS')[1].trim()}}.png" (error) ="onImgError($event)"></div>
                      </div>
                      <div _ngcontent-acq-c26="" class="display-flex text-center">
                         <!----><!---->
                         <p _ngcontent-acq-c26="" *ngIf="betViewData?.selectionName=='Computer Select'" class="ng-tns-c26-2 ng-star-inserted" ><span _ngcontent-acq-c26="" class="pbcomp">Computer</span> Selected first <strong _ngcontent-acq-c26="" class="ng-tns-c26-2"><span _ngcontent-acq-c26="" class="pbplayer">Player</span> awarded {{betViewData?.runnerRuns}} run advantage</strong></p>
                      
                         <p _ngcontent-acq-c26="" *ngIf="betViewData?.selectionName=='User Select'" class="ng-tns-c26-2 ng-star-inserted"><span _ngcontent-acq-c26="" class="pbcomp">Player</span> Selected first <strong _ngcontent-acq-c26="" class="ng-tns-c26-2"><span _ngcontent-acq-c26="" class="pbplayer">Computer</span> awarded {{betViewData?.runnerRuns}} run advantage</strong></p>
                    
                        </div>
                      <!---->
                      <div _ngcontent-acq-c26="" class="display-flex text-center ng-tns-c26-2 ng-star-inserted">
                         <!---->
                         <p _ngcontent-acq-c26="" *ngIf="betViewData?.amount>0" class="ng-tns-c26-2 ng-star-inserted"><span _ngcontent-acq-c26="" class="ng-tns-c26-2">Congratulations Yeah..! </span><strong _ngcontent-acq-c26="" class="won"> You Won {{betViewData?.amount}}</strong></p>
                          <p _ngcontent-acq-c26="" *ngIf="betViewData?.amount<0" class="ng-tns-c26-2 ng-star-inserted"><span _ngcontent-acq-c26="" class="ng-tns-c26-2">Opps..! </span><strong _ngcontent-acq-c26="" class="loss" style="color:red"> We are sorry to know that you Lost  {{-1*betViewData?.amount}}</strong></p>
                    
                         <!---->
                      </div>
                   </div>
                   <!---->
                   <div _ngcontent-acq-c26="" class="display-flex bg-black-div ng-trigger ng-trigger-fadeInOut">
                      <div _ngcontent-acq-c26="" class="dynamic-player-select">
                         <ul _ngcontent-acq-c26="" class="player-card-list">
                            <!----><!----><!----><!----><!----><!----><!----><!----><!---->
                            <li _ngcontent-acq-c26="" class="ng-tns-c26-2 selected-player ng-star-inserted" *ngFor="let r of userDta">
                               
                               <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">
                                  <p _ngcontent-acq-c26="" class="ng-tns-c26-2" style="font-weight: bold;">{{r.runnerName}}</p>
                                  <span _ngcontent-acq-c26="" class="ng-tns-c26-2">Final Run: {{r.runs}}</span>
                               </h6>
                            </li>
                           
                         </ul>
                        

                         <ul _ngcontent-acq-c26="" class="player-card-list">
                          <!----><!----><!---->
                          <li _ngcontent-acq-c26="" class="ng-tns-c26-2 computer-slt ng-star-inserted" *ngFor="let r of computerDta">
                             
                             <h6 _ngcontent-acq-c26="" class="ng-tns-c26-2">
                                <p _ngcontent-acq-c26="" class="ng-tns-c26-2" style="font-weight: bold;">{{r.runnerName}}</p>
                                <span _ngcontent-acq-c26="" class="ng-tns-c26-2">Final Run: {{r.runs}}</span>
                             </h6>
                          </li>
                          
                       </ul>
                      </div>
                   </div>
                </div>
             </div>

               
           </ng-container>

          </div>
        </div>

               <!-- casinoFooter -->
               <ng-container *ngIf="tokenCheck && dataLength">
                  <!-- footer -->
       <footer class="text-center text-white" style="background:black;">
         <!-- Grid container -->
         <div class="container p-4 pb-0">
           <!-- Section: Social media -->
           <section class="mb-4">
             <!-- Facebook -->
             <a class="btn text-white btn-floating m-1" style="background-color: #3b5998;" href="#!" role="button"><i
                 class="fab fa-facebook-f"></i></a>
       
             <!-- Twitter -->
             <a class="btn text-white btn-floating m-1" style="background-color: #55acee;" href="#!" role="button"><i
                 class="fab fa-twitter"></i></a>
       
             <!-- Google -->
             <a class="btn text-white btn-floating m-1" style="background-color: #dd4b39;" href="#!" role="button"><i
                 class="fab fa-google"></i></a>
       
             <!-- Instagram -->
             <a class="btn text-white btn-floating m-1" style="background-color: #ac2bac;" href="#!" role="button"><i
                 class="fab fa-instagram"></i></a>
       
             <!-- Linkedin -->
             <a class="btn text-white btn-floating m-1" style="background-color: #0082ca;" href="#!" role="button"><i
                 class="fab fa-linkedin-in"></i></a>
             <!-- Github -->
             <a class="btn text-white btn-floating m-1" style="background-color: #333333;" href="#!" role="button"><i
                 class="fab fa-github"></i></a>
           </section>
           <!-- Section: Social media -->
         </div>
         <!-- Grid container -->
         <div class="link">
           <div class="row m-0 no-gutters footer_div">
             <a href="#"> Privacy Policy</a> |
             <a href="#"> About Us</a> |
             <a href="#"> Terms & Conditions </a> |
             <a href="#"> Gambling can be addictive, Please play responsibly</a> |
       
           </div>
         </div>
         <div class="payment_infor">
           <p>Accept, process & disburse digital payments for your business.</p>
           <img style="width: 91%;" src="https://gamerswar.com/assets/images/social-icons/footer-logo.png"
             alt="Please waiting...">
         </div>
         <!-- Copyright -->
         <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2);">
           © 2022 Copyright:
           <a class="text-white" href="#">clubosg.com</a>
         </div>
         <!-- Copyright -->
       </footer>

       <!-- footerEnd -->
                 
               </ng-container>

               <ng-container *ngIf="dataLength==0">
                   <div class="text-warning text-center" style="margin-top:25vh;">No match</div>
               </ng-container>

           </div>

         
       </div>

       <ng-template #fantastyrule>
        <div matDialogTitle>
          <div class="rule-pop-content">
            <h4 class="modal-title">Term and Conditions</h4>

            <span  class="close" (click)="modalRef.hide()">&times;</span>

            <div _ngcontent-flk-c19="" class="modal-body">
              <p _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">1.</strong> Player battle is a skill game where any user can select real players and play against computer. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">2.</strong> User can select his set of players based on the event type. For example, 2vs2, 4vs4 or 6vs6 based on the game category. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">3.</strong> If the user selects first, the computer will get the default points. Vise versa if the computer selects first, the user will get the default points. (Default points are based on game category (2v2, 4v4, 6v6)) <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">4.</strong> If any player who has been selected is not included in playing 11 or didn't get opportunity to play (bat), Default points which was announced in advance will be given to them respectively. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">5.</strong> User is allowed to make any changes in the team before placing the bet, Once the bet is confirmed user will not be allowed to make any change in the current team. However, user is allowed to create new team and participate. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19="">6.</strong> Results will be announced post the match. <br _ngcontent-flk-c19=""><br _ngcontent-flk-c19=""><strong _ngcontent-flk-c19=""> 7.</strong> 1f the match got interrupted due to any situation such as rain/bad light and the match gets stopped. Default run/run scored whichever is the highest will be awarded for the players who haven't finished their quota. For example, Ina IND vs ENG T20 match England has completed playing 20 over and India got to play 10 over post that the match got stopped due to rain, Then Indian players will get points based on the above mentioned rule, (Note: This is not applicable to the player who has already got out before the match got stopped) </p>
           </div>
          </div>
        </div>
        
    </ng-template>
      
       <app-footer *ngIf="head_footer"></app-footer>
   </mat-sidenav-content>
</mat-sidenav-container>